// utils/users.js
import {privateApi} from '../utils/axios';

export const addUserFriend = async (friendId) => {
  const response = await privateApi.post('/users/add-friend', { friendId });
  return response.data;
};

export const getUserProfile = async () => {
  const response = await privateApi.get('/users/profile');
  return response.data;
};

export const updateUserProfile = async (userData) => {
  const response = await privateApi.put('/users/profile', userData);
  return response.data;
};

export const resetPassword = async (passwordData) => {
  const response = await privateApi.post('/users/reset-password', passwordData);
  return response.data;
};
